import React, { useState } from 'react';
import { Modal, Form, Input, Button, message } from 'antd';
import { useDispatch } from 'react-redux';
import { AppDispatch } from '../../../redux/store/store';
import { createTipoUsuario } from '../../../redux/actions/tipoUsuarios/TipoUsuarios';
import EmpresasSelect from '../../select/EmpresasSelect';

interface CrearTipoUsuarioModalProps {
  visible: boolean;
  onClose: (refresh?: boolean) => void;
}

const CrearTipoUsuarioModal: React.FC<CrearTipoUsuarioModalProps> = ({ visible, onClose }) => {
  const [form] = Form.useForm();
  const dispatch = useDispatch<AppDispatch>();
  const [loading, setLoading] = useState(false);
  const [selectedEmpresa, setSelectedEmpresa] = useState<any>(null);

  const handleEmpresaChange = (value: string, empresa: any) => {
    setSelectedEmpresa(empresa);
    form.setFieldsValue({ empresaId: value });
  };

  const handleSubmit = async () => {
    try {
      const values = await form.validateFields();
      setLoading(true);

      if (values.empresaId) {
        values.empresaId = Number(values.empresaId);
      }

      await dispatch(createTipoUsuario(values));

      message.success('Tipo de usuario creado exitosamente');
      form.resetFields();
      onClose(true);
    } catch (error) {
      console.error('Error al crear el tipo de usuario:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    form.resetFields();
    onClose();
  };

  return (
    <Modal
      title="Crear Nuevo Tipo de Usuario"
      open={visible}
      onCancel={handleCancel}
      footer={[
        <Button key="cancel" onClick={handleCancel}>
          Cancelar
        </Button>,
        <Button
          key="submit"
          type="primary"
          loading={loading}
          onClick={handleSubmit}
        >
          Crear
        </Button>,
      ]}
    >
      <Form
        form={form}
        layout="vertical"
        name="form_crear_tipo_usuario"
      >
        <Form.Item
          name="empresaId"
          label="Empresa"
          rules={[
            {
              required: true,
              message: 'Por favor seleccione una empresa',
            },
          ]}
        >
          <EmpresasSelect 
            onChange={handleEmpresaChange}
            placeholder="Seleccione una empresa"
          />
        </Form.Item>

        <Form.Item
          name="tipo_usuario"
          label="Nombre del Tipo de Usuario"
          rules={[
            {
              required: true,
              message: 'Por favor ingrese el nombre del tipo de usuario',
            },
            {
              max: 45,
              message: 'El nombre no debe exceder los 45 caracteres',
            }
          ]}
        >
          <Input placeholder="Ej. Administrador, Cliente, Doctor, etc." />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default CrearTipoUsuarioModal;